import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './root.css'

ReactDOM.render(<App />, document.getElementById('root'));
